import React from "react";

type AuthPageLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({
  children,
  className,
}) => (
  <section className="py-24">
    <div className={`mx-auto px-4 ${className ?? "max-w-md"}`}>{children}</div>
  </section>
);
